import { withHandlers, compose } from 'recompose'
import { connect } from 'react-redux'
import { servicesCheckboxClick } from 'actions/thirdParty'
import CheckboxList from 'components/common/FormElements/CheckboxList/CheckboxList'
import Theme from 'components/common/Theme/Theme'

const withControlHandlers = withHandlers({
  handleChange: ({ onChange, value, placeholder, servicesCheckboxClick }) => (checkboxValue, checked, revenue) => {
    const newValue =
      checked ?
        [...value, checkboxValue].filter(value => value !== placeholder) :
        value.filter(value => value !== checkboxValue)

    onChange(newValue)
    servicesCheckboxClick({ revenue })
  },
  handleReset: ({ onChange }) => () => onChange([])
})

const withEnterKeydownHandler = withHandlers({
  onKeyDown: () => e => e.keyCode === Theme.keyCode.ENTER && e.preventDefault()
})

export default compose(
  connect(null, { servicesCheckboxClick }),
  withControlHandlers,
  withEnterKeydownHandler
)(CheckboxList)
